var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShow)?_c('script',{attrs:{"type":"application/ld+json"}},[_vm._v("\n\t"+_vm._s(_vm.json)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }